import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5798adc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "unassociated-qr-container px-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message-group" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "This trailer's QR code isn't working"),
  /*#__PURE__*/_createElementVNode("div", null, "Please enter info to attach")
], -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = {
  key: 1,
  class: "trailer-side-selector"
}
const _hoisted_5 = {
  key: 2,
  class: "incorrect-company-container px-4"
}
const _hoisted_6 = { class: "message-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Incorrect Company", -1))
const _hoisted_8 = { class: "driver-company" }
const _hoisted_9 = { class: "uppercase" }
const _hoisted_10 = { class: "input-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanySelector = _resolveComponent("CompanySelector")!
  const _component_FbxInput = _resolveComponent("FbxInput")!
  const _component_InputModeToggle = _resolveComponent("InputModeToggle")!
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_TrailerAerial = _resolveComponent("TrailerAerial")!
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!

  return (!_ctx.messageIncorrectCompany && !_ctx.showTrailerSidePicker)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CompanySelector, { onSelectCompany: _ctx.onSelectCompany }, null, 8, ["onSelectCompany"]),
          _createElementVNode("div", null, [
            _createVNode(_component_FbxInput, {
              id: "trailerNumberSearch",
              class: "input-field",
              label: "Trailer Number",
              alert: _ctx.trailerAlert,
              limit: 6,
              type: _ctx.isInputText ? 'search' : 'number',
              modelValue: _ctx.trailerNumber,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trailerNumber) = $event))
            }, null, 8, ["alert", "type", "modelValue"]),
            _createVNode(_component_InputModeToggle, { onTrailerHasLetters: _ctx.onTrailerHasLetters }, null, 8, ["onTrailerHasLetters"])
          ]),
          _createVNode(_component_FbxButton, {
            "button-text": _ctx.actionText,
            disabled: _ctx.submitDisabled,
            showLoading: _ctx.isLoading,
            onClick: _ctx.showTrailerSidePickerOverlay
          }, null, 8, ["button-text", "disabled", "showLoading", "onClick"])
        ])
      ]))
    : (_ctx.showTrailerSidePicker)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_TrailerAerial, {
            backDisplay: "Back",
            frontDisplay: "Front",
            driverDisplay: "Driver Side",
            passengerDisplay: "Passenger Side",
            isLoading: _ctx.isLoading,
            onSideSelected: _ctx.selectQRSide,
            onAttachTrailer: _ctx.onSubmit
          }, null, 8, ["isLoading", "onSideSelected", "onAttachTrailer"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", null, [
              _createTextVNode(" You may only connect to "),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.driverCompany), 1),
              _createTextVNode(" trailers ")
            ])
          ]),
          _createVNode(_component_CompanyLogo, {
            company: _ctx.trailerCompany ?? undefined
          }, null, 8, ["company"]),
          _createElementVNode("div", null, [
            _createTextVNode(" Trailer "),
            _createElementVNode("span", _hoisted_9, "#" + _toDisplayString(_ctx.trailerNumber), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_FbxButton, {
              "button-text": "Attach Another Trailer",
              showLoading: _ctx.isLoading,
              onClick: _ctx.onAttachAnotherTrailer
            }, null, 8, ["showLoading", "onClick"]),
            _createVNode(_component_FbxButton, {
              "button-text": "Find Another Trailer",
              theme: "primaryOutline",
              class: "italic",
              showLoading: _ctx.isLoading,
              onClick: _ctx.onFindTrailer
            }, null, 8, ["showLoading", "onClick"])
          ])
        ]))
}